import React from "react";
import styled from "styled-components";
import { Typography, Alert } from "@arco-design/web-react";

const { Title, Text } = Typography;

// MUI -> Arco. makeStyles -> styled-components; the many unused style keys +
// dead imports (Button, PlusIcon, Grid) from the old template were dropped.
// theme.spacing(n) inlined at 8px/unit; Paper(elevation=2) -> a styled card.

const SummaryCards = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Card = styled.div`
  margin: 8px;
  flex-grow: 1;
  padding: 24px;
  background: var(--color-bg-2);
  border: 1px solid var(--color-border-2);
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.08);
`;

const Section = styled.div`
  padding-bottom: 16px;
`;

export function SummaryCardGroup({ children }) {
  return <SummaryCards>{children}</SummaryCards>;
}

export default function SummaryCard({ title, subTitle, titleElement, alertMessage, postSubTitle, children, value, topComponent, bottomComponent }) {
  return (
    <Card>
      <Title heading={5} style={{ marginTop: 0, color: "var(--color-text-3)" }}>
        {title} &nbsp; {titleElement && titleElement}
      </Title>

      {alertMessage && (
        <div style={{ padding: 10 }}>
          <Alert type="info" content={alertMessage} />
        </div>
      )}

      {subTitle && (
        <Section>
          <Text style={{ color: "rgb(var(--arcoblue-6))" }}>{subTitle}</Text>
        </Section>
      )}

      {topComponent && <Section>{topComponent}</Section>}

      {children || (
        <Title heading={3} style={{ margin: 0, color: "rgb(var(--arcoblue-6))" }}>
          {value}
        </Title>
      )}

      {bottomComponent && <Section>{bottomComponent}</Section>}

      {postSubTitle && (
        <Section>
          <Text style={{ color: "rgb(var(--arcoblue-6))" }}>{postSubTitle}</Text>
        </Section>
      )}
    </Card>
  );
}
